// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Lock = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <rect width={9} height={7} x={4.5} y={7.5} stroke="currentColor" rx={0.5} />
    <path
      fill="currentColor"
      d="M9 2a3 3 0 0 1 3 3c0 .887-.388 1.682-1 2.231V5a2 2 0 1 0-4 0v2.231C6.388 6.682 6 5.887 6 5a3 3 0 0 1 3-3"
    />
    <path fill="currentColor" d="M6 5h1v2H6zM11 5h1v1h-1zM11 6h1v1h-1zM8.5 9.5h1v3h-1z" />
  </svg>
);
const ForwardRef = forwardRef(Lock);
export default ForwardRef;
